import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-map_white_upload",
  "use": "icon-map_white_upload-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-map_white_upload\"><path d=\"M1024 645.248v330.752a48 48 0 0 1-48 48H48a48 48 0 0 1-48-48v-330.752a48 48 0 0 1 96 0V928h832v-282.752a48 48 0 0 1 96 0zM246.912 381.76L464.768 163.84v593.472a48 48 0 0 0 96 0V163.904l217.856 217.92a48 48 0 1 0 67.904-67.904L546.752 14.08a47.936 47.936 0 0 0-67.904 0L179.072 313.856a48 48 0 0 0 67.84 67.904z\" fill=\"#2b8eec\" p-id=\"3779\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/map/map_white_upload.svg
// module id = L3VF
// module chunks = 24